import React from 'react'
import ReactECharts from 'echarts-for-react'
import { EChartsOption } from 'echarts'
import { useTheme } from '../../../components/ThemeProvider'

interface InstitutionalApplicationRecordsChartProps {
  data: any
}

export default function InstitutionalApplicationRecordsChart({ data }: InstitutionalApplicationRecordsChartProps) {
  const theme = useTheme()

  const lightenColor = (color: string, percent: number) => {
    const num = parseInt(color.replace('#', ''), 16)
    const amt = Math.round(2.55 * percent)
    const R = (num >> 16) + amt
    const G = ((num >> 8) & 0x00ff) + amt
    const B = (num & 0x0000ff) + amt
    return `#${(0x1000000 + (R > 255 ? 255 : R) * 0x10000 + (G > 255 ? 255 : G) * 0x100 + (B > 255 ? 255 : B)).toString(16).slice(1)}`
  }

  const baseColor = theme?.primaryColor || '#3B82F6'

  const options: EChartsOption = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    legend: {
      data: ['P2P', '网络小贷', '消费分期', '现金分期', '代偿分期', '其他'],
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      data: ['近7天', '近15天', '近1月', '近3月', '近6月', '近1年'],
      axisLabel: {
        fontSize: 10,
      },
    },
    yAxis: {
      type: 'value',
      min: 0,
      axisLabel: {
        formatter: '{value}',
      },
    },
    series: [
      {
        name: 'P2P',
        type: 'bar',
        stack: 'total',
        label: {
          show: true,
          color: '#ffffff',
          fontSize: 10,
        },
        itemStyle: {
          color: baseColor,
        },
        data: [
          data?.nb_d7_apply_p2p_count ?? 0,
          data?.nb_d15_apply_p2p_count ?? 0,
          data?.nb_m1_apply_p2p_count ?? 0,
          data?.nb_m3_apply_p2p_count ?? 0,
          data?.nb_m6_apply_p2p_count ?? 0,
          data?.nb_m12_apply_p2p_count ?? 0,
        ],
      },
      {
        name: '网络小贷',
        type: 'bar',
        stack: 'total',
        label: {
          show: true,
          color: '#ffffff',
          fontSize: 10,
        },
        itemStyle: {
          color: lightenColor(baseColor, 10),
        },
        data: [
          data?.nb_d7_apply_xd_count ?? 0,
          data?.nb_d15_apply_xd_count ?? 0,
          data?.nb_m1_apply_xd_count ?? 0,
          data?.nb_m3_apply_xd_count ?? 0,
          data?.nb_m6_apply_xd_count ?? 0,
          data?.nb_m12_apply_xd_count ?? 0,
        ],
      },
      {
        name: '消费分期',
        type: 'bar',
        stack: 'total',
        label: {
          show: true,
          color: '#ffffff',
          fontSize: 10,
        },
        itemStyle: {
          color: lightenColor(baseColor, 20),
        },
        data: [
          data?.nb_d7_apply_xffq_count ?? 0,
          data?.nb_d15_apply_xffq_count ?? 0,
          data?.nb_m1_apply_xffq_count ?? 0,
          data?.nb_m3_apply_xffq_count ?? 0,
          data?.nb_m6_apply_xffq_count ?? 0,
          data?.nb_m12_apply_xffq_count ?? 0,
        ],
      },
      {
        name: '现金分期',
        type: 'bar',
        stack: 'total',
        label: {
          show: true,
          color: '#ffffff',
          fontSize: 10,
        },
        itemStyle: {
          color: lightenColor(baseColor, 30),
        },
        data: [
          data?.nb_d7_apply_xjfq_count ?? 0,
          data?.nb_d15_apply_xjfq_count ?? 0,
          data?.nb_m1_apply_xjfq_count ?? 0,
          data?.nb_m3_apply_xjfq_count ?? 0,
          data?.nb_m6_apply_xjfq_count ?? 0,
          data?.nb_m12_apply_xjfq_count ?? 0,
        ],
      },
      {
        name: '代偿分期',
        type: 'bar',
        stack: 'total',
        label: {
          show: true,
          color: '#ffffff',
          fontSize: 10,
        },
        itemStyle: {
          color: lightenColor(baseColor, 40),
        },
        data: [
          data?.nb_d7_apply_dcfq_count ?? 0,
          data?.nb_d15_apply_dcfq_count ?? 0,
          data?.nb_m1_apply_dcfq_count ?? 0,
          data?.nb_m3_apply_dcfq_count ?? 0,
          data?.nb_m6_apply_dcfq_count ?? 0,
          data?.nb_m12_apply_dcfq_count ?? 0,
        ],
      },
      {
        name: '其他',
        type: 'bar',
        stack: 'total',
        label: {
          show: true,
          color: '#ffffff',
          fontSize: 10,
        },
        itemStyle: {
          color: '#9CA3AF',
        },
        data: [
          data?.nb_d7_apply_qt_count ?? 0,
          data?.nb_d15_apply_qt_count ?? 0,
          data?.nb_m1_apply_qt_count ?? 0,
          data?.nb_m3_apply_qt_count ?? 0,
          data?.nb_m6_apply_qt_count ?? 0,
          data?.nb_m12_apply_qt_count ?? 0,
        ],
      },
    ],
  }

  return <ReactECharts option={options} style={{ height: '400px' }} />
}
